<template>
  <div class="m-0" v-if="isAnalyticalMission">
    <div class="text-xs-center" v-if="displayComputationWidget">
      <exo-mission-computation
        giveMeATour-v-step="17"
        gt_ParamOrbitTransfert1-v-step="33"
        gt_ParamOrbitTransfert2-v-step="9"
      ></exo-mission-computation>
    </div>
    <div v-if="displayResult">
      <div gt_ParamOrbitTransfert2-v-step="10"></div>
      <div
        v-if="gt_OrbitTransferParam2.thirdPlotDone"
        gt_ParamOrbitTransfert2-v-step="25"
      ></div>
      <div
        v-if="gt_OrbitTransferParam2.thirdPlotDone"
        gt_ParamOrbitTransfert2-v-step="28"
      ></div>
      <v-row>
        <v-container class="pb-3">
          <v-row no-gutters>
            <div class="d-inline-flex justify-center align-center">
              <span class="headline grey--text" giveMeATour-v-step="18">{{
                currentMission.name.toUpperCase()
              }}</span>
            </div>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="addPlotConfiguration()"
                  giveMeATour-v-step="20"
                  gt_ParamOrbitTransfert2-v-step="11"
                >
                  <icon
                    scale="1.5"
                    class="primary--text"
                    name="regular/chart-bar"
                  ></icon>
                </v-btn>
              </template>
              <span>Add plot</span>
            </v-tooltip>
            <div
              v-if="
                gt_OrbitTransferParam2.firstPlotDone &&
                !gt_OrbitTransferParam2.secondPlotDone
              "
              gt_ParamOrbitTransfert2-v-step="15"
            ></div>
            <div
              v-if="
                gt_OrbitTransferParam2.secondPlotDone &&
                !gt_OrbitTransferParam2.thirdPlotDone
              "
              gt_ParamOrbitTransfert2-v-step="19"
            ></div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="saveLayout()"
                  gt_ParamOrbitTransfert2-v-step="27"
                >
                  <icon scale="1.5" class="primary--text" name="save"></icon>
                </v-btn>
              </template>
              <span
                >Save the layout and the configurations of the dashboard</span
              >
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="dashboardTools().resetLayout(_self)"
                >
                  <icon
                    scale="1.5"
                    class="primary--text"
                    name="undo-alt"
                  ></icon>
                </v-btn>
              </template>
              <span
                >Reset the layout and the configurations of the dashboard</span
              >
            </v-tooltip>
          </v-row>
        </v-container>
      </v-row>
      <v-divider class="mt-0"></v-divider>
      <div class="px-3">
        <analytical-plot-config
          ref="plotConfig"
          v-if="currentResultsLog.results != null"
        ></analytical-plot-config>
        <grid-layout
          :layout.sync="gridlayout"
          :col-num="6"
          :row-height="7"
          :is-draggable="true"
          :is-resizable="true"
          :is-mirrored="false"
          :vertical-compact="true"
          :margin="[20, 10]"
          :use-css-transforms="true"
        >
          <grid-item
            v-if="!isAdcsDesignMission"
            :x="gridlayout[0].x"
            :y="gridlayout[0].y"
            :w="gridlayout[0].w"
            :h="gridlayout[0].h"
            :i="gridlayout[0].i"
            :minH="5"
            :minW="1"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#2A94DE"
              awesomeicon="tachometer-alt"
              title="ΔV"
              :ref="`${statsCardName}${gridlayout[0].i}`"
              :cardId="`${statsCardName}${gridlayout[0].i}`"
              :value="computeResultToDisplay(['deltaV'])"
              :unit="getResultUnitLabel('deltaV')"
              giveMeATour-v-step="19"
            />
          </grid-item>
          <grid-item
            v-if="!isAdcsDesignMission"
            :x="gridlayout[1].x"
            :y="gridlayout[1].y"
            :w="gridlayout[1].w"
            :h="gridlayout[1].h"
            :i="gridlayout[1].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#FF7E0D"
              icon="ev_station"
              title="Used propellant"
              :ref="`${statsCardName}${gridlayout[1].i}`"
              :cardId="`${statsCardName}${gridlayout[1].i}`"
              :value="computeResultToDisplay(['usedPropellant'])"
              :unit="getResultUnitLabel('usedPropellant')"
            />
          </grid-item>
          <grid-item
            v-if="!isAdcsDesignMission"
            :x="gridlayout[2].x"
            :y="gridlayout[2].y"
            :w="gridlayout[2].w"
            :h="gridlayout[2].h"
            :i="gridlayout[2].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#38AD38"
              icon="timelapse"
              title="Thrust duration"
              :ref="`${statsCardName}${gridlayout[2].i}`"
              :cardId="`${statsCardName}${gridlayout[2].i}`"
              :value="computeResultToDisplay(['thrustDuration'])"
              :unit="getResultUnitLabel('thrustDuration')"
            />
          </grid-item>
          <grid-item
            v-if="!isAdcsDesignMission"
            :x="gridlayout[3].x"
            :y="gridlayout[3].y"
            :w="gridlayout[3].w"
            :h="gridlayout[3].h"
            :i="gridlayout[3].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#F72C2C"
              icon="timer"
              title="Mission duration"
              :ref="`${statsCardName}${gridlayout[3].i}`"
              :cardId="`${statsCardName}${gridlayout[3].i}`"
              :value="computeResultToDisplay(['missionDuration'])"
              :unit="getResultUnitLabel('missionDuration')"
            />
          </grid-item>
          <grid-item
            v-if="isAdcsDesignMission"
            :x="gridLayoutForADCS[0].x"
            :y="gridLayoutForADCS[0].y"
            :w="gridLayoutForADCS[0].w"
            :h="gridLayoutForADCS[0].h"
            :i="gridLayoutForADCS[0].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#38AD38"
              icon="timer"
              title="Control time thruster on"
              :ref="`${statsCardName}${gridLayoutForADCS[0].i}`"
              :cardId="`${statsCardName}${gridLayoutForADCS[0].i}`"
              :value="
                computeResultToDisplay(['controllabilityDurationThrusterOn'])
              "
              :unit="getResultUnitLabel(['controllabilityDurationThrusterOn'])"
            />
          </grid-item>
          <grid-item
            v-if="isAdcsDesignMission"
            :x="gridLayoutForADCS[1].x"
            :y="gridLayoutForADCS[1].y"
            :w="gridLayoutForADCS[1].w"
            :h="gridLayoutForADCS[1].h"
            :i="gridLayoutForADCS[1].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#2A94DE"
              icon="timer"
              title="Wheel desaturation time"
              :ref="`${statsCardName}${gridLayoutForADCS[0].i}`"
              :cardId="`${statsCardName}${gridLayoutForADCS[0].i}`"
              :value="
                computeResultToDisplay(['desaturationDurationThrusterOff'])
              "
              :unit="getResultUnitLabel(['desaturationDurationThrusterOff'])"
            />
          </grid-item>
          <grid-item
            v-if="isAdcsDesignMission"
            :x="gridLayoutForADCS[2].x"
            :y="gridLayoutForADCS[2].y"
            :w="gridLayoutForADCS[2].w"
            :h="gridLayoutForADCS[2].h"
            :i="gridLayoutForADCS[2].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#FF7E0D"
              icon="timer"
              title="Detumble duration"
              :ref="`${statsCardName}${gridLayoutForADCS[0].i}`"
              :cardId="`${statsCardName}${gridLayoutForADCS[0].i}`"
              :value="computeResultToDisplay(['detumbleDuration'])"
              :unit="getResultUnitLabel(['detumbleDuration'])"
            />
          </grid-item>
          <grid-item
            v-if="isAdcsDesignMission"
            :x="gridLayoutForADCS[3].x"
            :y="gridLayoutForADCS[3].y"
            :w="gridLayoutForADCS[3].w"
            :h="gridLayoutForADCS[3].h"
            :i="gridLayoutForADCS[3].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#F72C2C"
              icon="timelapse"
              title="Achievable duty cycle"
              :ref="`${statsCardName}${gridLayoutForADCS[0].i}`"
              :cardId="`${statsCardName}${gridLayoutForADCS[0].i}`"
              :value="computeResultToDisplay(['achievableDutyCycle'])"
              :unit="getResultUnitLabel(['achievableDutyCycle'])"
            />
          </grid-item>
          <grid-item
            :x="gridlayout[4].x"
            :y="gridlayout[4].y"
            :w="gridlayout[4].w"
            :h="gridlayout[4].h"
            :i="gridlayout[4].i"
            :isResizable="false"
          >
            <div v-if="currentMission && currentResultsLog.results">
              <results-card
                :root="_self"
                giveMeATour-v-step="21"
                gt_ParamOrbitTransfert1-v-step="34"
              ></results-card>
            </div>
            <div gt_ParamOrbitTransfert1-v-step="35"></div>
          </grid-item>
          <div v-for="(config, index) in configurations" :key="config.id">
            <grid-item
              v-if="config.gridItem"
              :x="config.gridItem.x"
              :y="config.gridItem.y"
              :w="config.gridItem.w"
              :h="config.gridItem.h"
              :i="config.gridItem.i"
              :isDraggable="config.isDraggable"
              @resized="plotCardResized"
              @resize="plotCardResized"
            >
              <v-card tile height="100%">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-btn
                      color="primary"
                      @click.stop="
                        dashboardTools().editPlotConfiguration(_self, index)
                      "
                      left
                      dark
                      text
                      gt_ParamOrbitTransfert2-v-step="26"
                    >
                      <v-icon dark medium>edit</v-icon>
                      Edit
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click.stop="
                        dashboardTools().removePlotConfiguration(
                          _self,
                          config.gridItem.i
                        )
                      "
                      left
                      dark
                      text
                    >
                      <v-icon dark medium>delete</v-icon>
                      Delete
                    </v-btn>
                    <div
                      class="d-inline-block grey--text font-italic caption mt-2"
                      style="position: absolute"
                      :config="config"
                      v-if="
                        config &&
                        config.filters.length !== 0 &&
                        config.filters[0].path.length !== 0
                      "
                    >
                      <u v-if="config.filters.length === 1">Filter:</u>
                      <u v-else>Filters:</u>
                      <span
                        v-for="filter in config.filtersToDisplay"
                        :key="filter"
                      >
                        {{ filter }}
                        <span
                          v-if="filter !== config.filtersToDisplay.slice(-1)[0]"
                          >-</span
                        >
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <plot-item
                  :gridlayout="gridlayout"
                  height="100%"
                  :root="_self"
                  :config="config"
                  :id="`${plotingAreaName}${config.gridItem.i}`"
                  :ref="`${plotingAreaName}${config.gridItem.i}`"
                  class="elevation-5 mt-4"
                >
                </plot-item>
              </v-card>
            </grid-item>
          </div>
        </grid-layout>
      </div>
    </div>
    <v-tour
      name="computationWidgetTour"
      :steps="computationWidgetSteps"
    ></v-tour>
    <v-tour
      name="resultsTour"
      :steps="resultsTourSteps"
      :callbacks="customTourCallback"
    ></v-tour>
    <v-tour
      name="paramOrbitalTransfer1TourResult"
      :steps="steps_analytical_dashboard"
      :callbacks="customTourCallback"
      :options="noSkipStepOption"
    ></v-tour>
    <v-tour
      name="paramOrbitalTransfer2TourResult"
      :steps="steps_analytical_dashboard2"
      :callbacks="customTourCallback"
      :options="noSkipStepOption"
    ></v-tour>
  </div>
</template>

<script>
import resultsDescription from '../../tools/resultsDescription.json'
import dashboardComponents from '../../components/Dashboard/index.js'
import dataTools from '../../tools/data.js'
import dashboardTools from '../../tools/dashboard.js'
import { mapGetters, mapActions } from 'vuex'
import { noSkipStepOption } from '../../components/GuidedTutorials/guidedTutorialConstraints.js'
import guidedTutorialParamOrbitalTransfer2, {
  steps_analytical_dashboard2
} from '../../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer2.js'
import guidedTutorialParamOrbitalTransfer1, {
  steps_analytical_dashboard
} from '../../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer1.js'
import Vue from 'vue'
import plotInput from '../../mixins/plotInput.js'
import plotLayout from '../../mixins/plotLayout.js'
import plotData from '../../mixins/plotData.js'
import Plotly from 'plotly.js-dist'
import errorMixin from '../../mixins/logHandler.js'
import { setTimeout } from 'timers'

Vue.use(dashboardComponents)

export default {
  name: 'AnalyticalDashboard',
  mixins: [errorMixin, plotLayout, plotInput, plotData],
  data() {
    const self = this
    return {
      configurations: [],
      isDrawn: [],
      configuration: null,
      type: 'ParametricStudyResult',
      plotingAreaName: 'plotingAreaAnalytical',
      statsCardName: 'statsCard',
      defaultLayout: [
        { x: 0, y: 0, w: 1, h: 6, i: '0' },
        { x: 1, y: 0, w: 1, h: 6, i: '1' },
        { x: 2, y: 0, w: 1, h: 6, i: '2' },
        { x: 3, y: 0, w: 1, h: 6, i: '3' },
        { x: 4, y: 0, w: 1, h: 21, i: '4' }
      ],
      gridlayout: [
        { x: 0, y: 0, w: 1, h: 6, i: '0' },
        { x: 1, y: 0, w: 1, h: 6, i: '1' },
        { x: 2, y: 0, w: 1, h: 6, i: '2' },
        { x: 3, y: 0, w: 1, h: 6, i: '3' },
        { x: 4, y: 0, w: 1, h: 21, i: '4' }
      ],
      gridLayoutForADCS: [
        { x: 0, y: 0, w: 1, h: 6, i: '0' },
        { x: 1, y: 0, w: 1, h: 6, i: '1' },
        { x: 2, y: 0, w: 1, h: 6, i: '2' },
        { x: 3, y: 0, w: 1, h: 6, i: '3' }
      ],
      computationWidgetSteps: [
        {
          target: '[giveMeATour-v-step="17"]',
          content:
            'You can start the <strong>computation</strong> of your mission by clicking on this button.'
        }
      ],
      noSkipStepOption: noSkipStepOption,
      steps_analytical_dashboard: steps_analytical_dashboard,
      steps_analytical_dashboard2: steps_analytical_dashboard2,
      addPlotIsClicked: false,
      resultsTourSteps: [
        {
          target: '[giveMeATour-v-step="18"]',
          content:
            'The computation has ended, the <strong>results</strong> are now displayed. We will navigate throughout the different options available.',
          params: {
            placement: 'right'
          }
        },
        {
          target: '[giveMeATour-v-step="19"]',
          content:
            'The <strong>stats cards</strong> give some meaningful results of the computation.'
        },
        {
          target: '[giveMeATour-v-step="20"]',
          content:
            'You can add different <strong>plots</strong> by clicking on this button. They will be displayed below the cards.'
        },
        {
          target: '[giveMeATour-v-step="21"]',
          content:
            'The <strong>"View"</strong> button gives you further details about the results of the mission. <br>You may also want to export the results with the <strong>"Export"</strong> button.'
        }
      ],
      customTourCallback: {
        onNextStep: (currentStep) => {
          if (this.gt_OrbitTransferParam1.isActive) {
            guidedTutorialParamOrbitalTransfer1.onNextAnaDashboard(
              currentStep,
              this
            )
          } else if (this.gt_OrbitTransferParam2.isActive) {
            guidedTutorialParamOrbitalTransfer2.onNextAnaDashboard(
              this,
              currentStep
            )
          }
        },
        onSkip: () => {
          if (this.gt_OrbitTransferParam1.isActive) {
            guidedTutorialParamOrbitalTransfer1.stopAllTours(this)
          }
        },
        onFinish: () => {
          if (this.giveMeATour) {
            this.startATour(false)
          } else if (
            this.gt_OrbitTransferParam1.isActive &&
            this.displayResult
          ) {
            guidedTutorialParamOrbitalTransfer1.stopAllTours(this)
          } else {
            guidedTutorialParamOrbitalTransfer2.stopAllTours(this)
          }
        }
      }
    }
  },

  created() {
    window.addEventListener('beforeunload', this.saveLayout)
  },

  mounted() {
    if (this.giveMeATour) {
      this.$tours['computationWidgetTour'].start()
    } else if (this.gt_OrbitTransferParam1.isActive) {
      this.$tours['paramOrbitalTransfer1TourResult'].start()
    } else if (this.gt_OrbitTransferParam2.isActive) {
      this.$tours['paramOrbitalTransfer2TourResult'].start()
    }
    this.$root.$on('current-results-updated', this.currentResultsUpdatedHandler)

    setTimeout(() => {
      this.loadLayout()
    }, 1)

    this.$root.$on('create-plot', this.createPlotHandler)
  },

  beforeDestroy() {
    this.$root.$off(
      'current-results-updated',
      this.currentResultsUpdatedHandler
    )
    this.$root.$off('create-plot', this.createPlotHandler)
  },

  // TODO : the grid layout and analytical-plot-config consume a lot
  // of memory when switching between dashboards from top nav bar
  // one bad workaround is to reload the page : document.location.reload()
  // but the user rendering is not nice
  // removing keep-active from min page doesn't change anything (and will have side effects
  // as it is useful for forms.

  computed: {
    ...mapGetters([
      'currentUser',
      'currentMission',
      'currentResultsLog',
      'giveMeATour',
      'gt_OrbitTransferParam1',
      'gt_OrbitTransferParam2'
    ]),
    displayComputationWidget() {
      return this.computationNeeded || !this.resultsLoaded
    },
    displayResult() {
      return this.resultsLoaded && !this.computationNeeded
    },
    computationNeeded() {
      return (
        this.currentMission &&
        this.currentMission.computationRequested &&
        this.currentMission.computationLogId === ''
      )
    },
    resultsLoaded() {
      return (
        this.currentResultsLog != null && this.currentResultsLog.results != null
      )
    },
    isAnalyticalMission() {
      return (
        this.currentMission != null &&
        this.currentMission.typeName === 'ParametricStudyRequest'
      )
    },
    isAdcsDesignMission() {
      return this.currentMission.type === 'ADCS Design'
    },
    resultAvailable() {
      return (
        this.isAnalyticalMission &&
        this.resultsLoaded &&
        Array.isArray(this.currentResultsLog.results)
      )
    }
  },
  watch: {
    displayResult() {
      if (this.gt_OrbitTransferParam2.isActive) {
        this.$tours['paramOrbitalTransfer2TourResult'].start(1)
      } else if (this.gt_OrbitTransferParam1.isActive) {
        //setTimeout needed, otherwise the pop-up doesn't show in the right place
        setTimeout(() => {
          this.$tours['paramOrbitalTransfer1TourResult'].start(1)
        }, 50)
      }
    },
    'gt_OrbitTransferParam2.firstPlotDone'(val) {
      if (this.gt_OrbitTransferParam2.firstPlotDone) {
        this.$tours['paramOrbitalTransfer2TourAnaPlot'].stop()
        this.$tours['paramOrbitalTransfer2TourResult'].start(3)
      }
    },
    'gt_OrbitTransferParam2.secondPlotDone'(val) {
      if (this.gt_OrbitTransferParam2.secondPlotDone) {
        this.$tours['paramOrbitalTransfer2TourAnaPlot'].stop()
        this.$tours['paramOrbitalTransfer2TourResult'].start(4)
      }
    },
    'gt_OrbitTransferParam2.thirdPlotDone'(val) {
      if (this.gt_OrbitTransferParam2.thirdPlotDone) {
        this.$tours['paramOrbitalTransfer2TourResult'].start(5)
      }
    }
  },
  methods: {
    ...mapActions([
      'startATour',
      'start_gt_OrbitTransferParam1',
      'start_gt_OrbitTransferParam2'
    ]),

    currentResultsUpdatedHandler() {
      this.loadLayout()
      setTimeout(() => {
        this.resizeAllStatsCardResized()
      }, 200)
    },
    createPlotHandler(config, plotingArea, fromLayoutSave) {
      if (!fromLayoutSave && config.layout) {
        config.gridItem.h = 25
      }
      // Use timeout as workaround because nextTick doesnt work as expected
      setTimeout(() => {
        // Not nice but no workaround possible here (used to fit exactly the parent height)
        let el = this.$refs[`${this.plotingAreaName}${config.gridItem.i}`]
        if (el) {
          el = el[0]
          let parent = el ? el.$parent : undefined
          if (parent) {
            config.layout.height = parent.$el.clientHeight - 50
            if (
              config.data[0].x
                .filter((data) => !isNaN(data) || typeof data === 'string')
                .some(isNaN)
            ) {
              config.layout.xaxis.categoryorder = 'array'
              config.layout.xaxis.categoryarray = [...config.data[0].x] // to create a new array
              config.layout.xaxis.categoryarray.sort()
            }
            if (
              config.data[0].y
                .filter((data) => !isNaN(data) || typeof data === 'string')
                .some(isNaN)
            ) {
              config.layout.yaxis.categoryorder = 'array'
              config.layout.yaxis.categoryarray = [...config.data[0].y] // to create a new array
              config.layout.yaxis.categoryarray.sort()
            }
            Plotly.react(plotingArea, config.data, config.layout, {
              responsive: true
            })
            plotingArea.addEventListener('mouseover', (data) => {
              config.isDraggable = false
            })
            plotingArea.addEventListener('mouseleave', (data) => {
              config.isDraggable = true
            })
          }
        }
      }, 100)
    },

    dashboardTools() {
      return dashboardTools
    },
    saveLayout() {
      dashboardTools.saveLayout(this)
    },
    loadLayout() {
      if (this.currentMission) {
        if (this.currentMission.layout) {
          let missionLayout = JSON.parse(this.currentMission.layout)
          dataTools.loadGridLayoutConfig(missionLayout, this)
        } else {
          let missionLayout = { configurations: [], layout: this.defaultLayout }
          dataTools.loadGridLayoutConfig(missionLayout, this)
        }
      }
      dashboardTools.removeDuplicatedGridItem(this)
      if (this.giveMeATour) {
        setTimeout(() => {
          this.$tours['resultsTour'].start()
        }, 2000)
      }
    },
    resizeAllStatsCardResized() {
      this.statsCardResized(0)
      this.statsCardResized(1)
      this.statsCardResized(2)
      this.statsCardResized(3)
    },

    statsCardResized(i) {
      return dashboardTools.statsCardResized(this, i)
    },

    plotCardResized(i, newH, newW, newHPx, newWPx) {
      let update = {
        width: newWPx,
        height: newHPx - 50 // TODO find a better way to get this value
      }
      let plotingArea = document.getElementById(`${this.plotingAreaName}${i}`)
      if (plotingArea != null) {
        try {
          Plotly.relayout(plotingArea, update)
        } catch (e) {
          console.log('Error calling Plotly.relayout')
        }
      }
    },

    addPlotConfiguration() {
      guidedTutorialParamOrbitalTransfer2.handleClickOnAddPlotGuidedTutorial(
        this
      )
      dashboardTools.removeDuplicatedGridItem(this)
      let lastId = 0
      if (this.configurations.length > 0) {
        lastId = this.configurations.reduce((acc, curr) => {
          return curr.id > acc.id ? curr : acc
        }).id
      }
      let newId = lastId + 1
      let newConfig = this.buildEmptyConfiguration(newId)
      this.configuration = newConfig
      let biggestY = this.gridlayout.reduce((acc, curr) => {
        return acc.y > curr.y ? acc : curr
      }, this.gridlayout[0])
      let gridItem = {
        x: 0,
        y: biggestY.y + biggestY.h,
        w: 2,
        h: 5,
        i: `${'plot' + newId}`
      }
      this.configuration.gridItem = gridItem
      this.configurations.push(this.configuration)
      this.$nextTick(() => {
        this.gridlayout.push(this.configuration.gridItem)
        this.$nextTick(() => {
          let plotingArea = document.getElementById(
            `${this.plotingAreaName}${this.configuration.gridItem.i}`
          )
          if (plotingArea != null) {
            this.$root.$emit('set-plot-config', this.configuration, plotingArea)
          }
          this.$refs.plotConfig.drawer = !this.$refs.plotConfig.drawer
        })
      })
    },

    getResultFieldType(field) {
      return resultsDescription.ParametricStudyResult[field].type
    },

    getResultUnitLabel(field) {
      let fieldType = this.getResultFieldType(field)
      return (
        ' ' + dataTools.getUnitDisplayed(dataTools.getDefaultGuiUnit(fieldType))
      )
    },

    computeResultToDisplay(fieldPath) {
      return this.computeRange(
        this.getResultFieldType(fieldPath[fieldPath.length - 1]),
        fieldPath,
        null
      )
    },

    computeRange(fieldType, fieldPath, results) {
      let currentResults = results
      if (currentResults == null) {
        if (!this.resultAvailable) {
          return ''
        } else {
          currentResults = this.currentResultsLog.results
        }
      }
      let allVals = dataTools
        .getUniqueValues(currentResults, fieldPath)
        .filter((value) => !isNaN(value))
      let min = dataTools.convertSi2Display(fieldType, Math.min(...allVals))
      let max = dataTools.convertSi2Display(fieldType, Math.max(...allVals))
      if (min === max) {
        return min.toString()
      } else {
        if (min.toString().includes('Infinity')) {
          return ''
        }
        let displayedString = '[' + min
        allVals.length === 2
          ? (displayedString += '; ')
          : (displayedString += ' ... ')
        return displayedString + max + ']'
      }
    },
    // TODO MFI copied from analytical mission, it would be better to reuse the code

    // -------------------------------------------------------------------
    mergeString(fieldPath, results) {
      let currentResults = results
      if (currentResults == null) {
        if (!this.resultAvailable) {
          return ''
        } else {
          currentResults = this.currentResultsLog.results
        }
      }
      let uniqueVals = dataTools.getUniqueValues(currentResults, fieldPath)
      if (uniqueVals.length === 1) {
        return uniqueVals[0]
      } else {
        return uniqueVals
      }
    },

    isStringInside(expected, fieldPath, results) {
      let currentResults = results
      if (currentResults == null) {
        if (!this.resultAvailable) {
          return ''
        } else {
          currentResults = this.currentResultsLog.results
        }
      }
      return (
        currentResults.filter(
          (element) => dataTools.getValue(element, fieldPath) === expected
        ).length > 0
      ) // TODO MFI stop on first would be better
    },

    getCurrentAPI() {
      if (this.currentMission) {
        return this.getAPI(this.currentMission.typeName + 's')
      }
    },

    getAPI(objectAPI) {
      return '/users/' + this.currentUser.id + '/' + objectAPI.toLowerCase()
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');
</style>
